import { spacing } from "@izettle/otto"
import { useLocalization } from "@izettle/tenko-react"

import { Flex, Title2, RegularText, WallSuccess } from "@/core/components/shared"

type OptOutSuscessComponentProps = {
  orgName: string
}

export const OptOutSuccessComponent = ({ orgName }: OptOutSuscessComponentProps) => {
  const { text } = useLocalization()

  return (
    <>
      <WallSuccess style={{ flex: 1, marginBottom: spacing.small }}>
        <img
          src="https://cdn.izettle.com/customers/success-stamp.svg"
          alt="success"
          height="128px"
        />
        <Title2>{text("SIGNUP_DONE")}</Title2>
        <RegularText style={{ margin: 0 }}>
          {text("SIGNUP_OPTOUT_SUCCESS", [orgName])}
        </RegularText>
      </WallSuccess>

      <Flex>
        <RegularText>{text("SIGNUP_OPTOUT_SUCCESS_HELP", [orgName])}</RegularText>
      </Flex>
    </>
  )
}
